// @ts-nocheck
import * as React from 'react'
import { Select, FormControl, MenuItem, OutlinedInput, FormHelperText } from '@material-ui/core'
import styled from 'styled-components'
import InputLabel from './InputLabel'
import { useFieldArray } from 'react-hook-form'

const ITEM_HEIGHT = 34
const ITEM_PADDING_TOP = 8
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
	getContentAnchorEl: null,
	anchorOrigin: {
		vertical: 'bottom',
		horizontal: 'left',
	},
}

const StyledFormControl = styled(FormControl)`
	width: 100%;
`

const StyledSelect = styled(Select)`
	background-color: var(--optionalBackground);
	height: 34px;
	.MuiOutlinedInput-notchedOutline {
		border: none;
	}
	& .MuiSelect-select:focus {
		background-color: transparent;
	}
	border: ${({ $isError }) => $isError && '1px solid red'};
	padding: 9px 13px;
	@media (max-width: 576px) {
		padding: 9px 5px;
	}
`

const StyledFormHelperText = styled(FormHelperText)`
	&.MuiFormHelperText-root {
		color: red;
		font-size: 10px;
		font-family: 'Work Sans', OpenSansHebrew;
	}
`

const StyledMenuItem = styled(MenuItem)`
	font-size: 13px;
`

// TODO - Ben - make it generic with value and onChange passed from outside
const Dropdown = ({ label, options, error, helperText = [], setValue, name, testId }) => {
	const [optionChosen, setOptionChosen] = React.useState('')

	const handleChange = (event) => {
		const {
			target: { value },
		} = event
		setOptionChosen(
			// On autofill we get a the stringified value.
			typeof value === 'string' ? value.split(',') : value
		)
		setValue(name, value, { shouldValidate: true })
	}

	return (
		<div data-testid="dropdown-container">
			<InputLabel htmlFor="component-simple" $isContactUs>
				{label}
			</InputLabel>
			<StyledFormControl sx={{ m: 1, width: 300, mt: 3 }}>
				<StyledSelect
					displayEmpty
					value={optionChosen}
					onChange={handleChange}
					input={<OutlinedInput />}
					MenuProps={MenuProps}
					$isError={error}
					data-testid={testId}
				>
					{options.map((optionName) => (
						<StyledMenuItem key={optionName} value={optionName} data-testid="dropdown-option">
							{optionName}
						</StyledMenuItem>
					))}
				</StyledSelect>
				{error && <StyledFormHelperText data-testid="input-error-message">{helperText}</StyledFormHelperText>}
			</StyledFormControl>
		</div>
	)
}

export default Dropdown
